module.exports = __webpack_public_path__ + "img/level_center_talk.05636e75.gif";